import * as React from 'react'
import type { Recipient } from 'types/list'
import RecipientTag from 'components/common/email-groups/recipient-tag'

/**
 * Recipient typeahead option component for dropdown selections
 * Wraps RecipientTag for use in typeahead dropdown with removal functionality
 * @param value - Recipient object with ID and recipient properties
 * @param onRemove - Callback when the option is removed
 */
class RecipientTypeaheadOption extends React.Component<{
  value: {
    id: number
  } & Recipient
  onRemove: (...args: Array<any>) => any
}> {
  render(): React.ReactNode {
    return (
      <RecipientTag
        index={this.props.value.id}
        appearance="oneline"
        recipient={this.props.value}
        onRemove={() => {
          this.props.onRemove(this.props.value)
        }}
      />
    )
  }
}

export default RecipientTypeaheadOption
